<template>
    <div class="chartBox">
        <div ref="childChart" class="top_chart" id="deliveryChart" style="height: 392px"></div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import { EleResize } from '../assets/js/esresize';
    export default {
        name:'webIndexChart',
        props:{
            chartData:Object,
            isClick: Boolean
        },
        data(){
            return{
                myChart: null,
            }
        },
        //--在watch中监听 宽高变化   
        //（宽高有变化的时候会触发watch  然后跟新视图，由于父组件直接传过来的数据不能直接更新子组件视图，
        //    所以在子组件用一个新的变量去接收父组件传递过来的参数）
		watch:{
            chartData:{
                handler(){
                    this.myChart.setOption({
                        xAxis: {
                            data: this.chartData.title,
                        },
                        series: [{
                            data: this.chartData.inData,
                        },
                        {
                            data: this.chartData.outData,
                        }]
                    })
                },
                deep: true
            }
        },
        methods:{

            //echart图表渲染
            getEchart() {
                var _this = this
                var chartDom = document.getElementById('deliveryChart')
                this.myChart = echarts.init(chartDom);
                var option;
                option = {
                    title: {
                        text: '出入库数据',
                    },
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        // y:'center',     //可设定图例在上、下、居中
                        padding:[10,10,0,0],   //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
                        data: ['入库数据', '出库数据']
                    },
                    color:['#FF6968','#50DAF4','#EEDA2D'],//图例颜色设置
                    grid: {show:'true',borderWidth:'1',height:"60%",width:"80%",y:"20%",x:"12%",y2: 140},
                    xAxis: {
                        type: 'category',
                        data: this.chartData.title,     //.map(function (str) { return str.replace(',', '\n\n'); })将X轴数据显示为两行
                        // data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                        axisLabel: {
                            interval: 0,        //X轴数据全部显示
                            //rotate: 50          //X轴数据倾斜显示
                            formatter:function(params) {
                                return params.replace(',', '\n');
                            },
                        },
                    },
                    color: ['#909399'],
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        top: '10%',
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#323232b3'
                            }
                        }
                    },
                    series: [{
                        name: '入库数据',
                        data: this.chartData.inData,
                        // data: [120, 200, 150, 80, 70, 110, 130],
                        type: 'bar',
                        barWidth: 40,
                        itemStyle:{
                            normal:{
                                color:'#8F60BF'
                            }
                        },
                    },
                    {
                        name: '出库数据',
                        data: this.chartData.outData,
                        // data: [120, 200, 150, 80, 70, 110, 130],
                        type: 'line',
                        // smooth:true,//折点是圆弧状的
                        // showSymbol: true,
                        // symbol: 'circle',     //折点设定为实心点
                        symbolSize: 10,   //设定实心点的大小
                        itemStyle:{ 
                            normal:{ 
                                color:'#84BD41', //折点颜色
                                lineStyle:{ 
                                    color:'#84BD41' //折线颜色
                                } 
                            } 
                        }
                    }]
                };

                option && this.myChart.setOption(option);
                let listener = function() {
                    _this.myChart && _this.myChart.resize();
                };
                EleResize.on(document.getElementById('deliveryChart'), listener);
            },
        },
        created(){},
        mounted(){
            this.getEchart()
        },
    }
</script>

<style scoped>
.chartBox {
    padding: 0;
    margin: 0;
    border-radius: 10px;
    background-color: #fff;
}
.top_chart {
    flex: 1;
    overflow: hidden;
}
</style>